import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  resetData: () => ({}),
  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().nudgeAngel.paging;
      let { result, status } = await Api.post(`nudge-angels/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        ...sortOption,
      });

      status === 200 && nudgeAngelDispatcher.getDataSuccess(result);
    },
  createNudgeAngel:
    (payload, onSuccess, onError) =>
    async ({ Api }) => {
      let { status } = await Api.post(`nudge-angels`, payload);
      status === 200 ? onSuccess() : onError();
    },
  editNudgeAngel:
    (id, payload, onSuccess, onError) =>
    async ({ Api }) => {
      let { status } = await Api.put(`nudge-angels/${id}`, payload);
      status === 200 ? onSuccess() : onError();
    },
  deleteNudgeAngel:
    (id, onSuccess, onError) =>
    async ({ Api }) => {
      let { status } = await Api.delete(`nudge-angels/${id}`);
      status === 200 ? onSuccess() : onError();
    },

  updateNudgeAngelStatus:
    (id, activeStatus = false, onSuccess, onError) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.put(`nudge-angels/${id}/status`, {
        isActive: activeStatus,
      });
      if (status === 200) {
        customToast(
          'success',
          `${activeStatus ? 'Activate' : 'Deactivate'} successfully`
        );
        onSuccess();
      } else {
        onError();
      }
    },
  getDetailNudgeAngel:
    (id, onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`nudge-angels/${id}`);
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },
  getEventTriggers:
    (onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`nudge-angels/event-triggers`);
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },
};

const nudgeAngelDispatcher = synthesize('nudgeAngel', mapDispatchToAC);
export default nudgeAngelDispatcher;
